module.exports = __webpack_public_path__ + "img/image1.9c3df723.png";